export enum LocalStorageKeys {
  ID_TOKEN = "id_token",
}
